function consultationPatientWA(payload) {
    var WA = `Nuevo Paciente y consulta con ${payload.doctor_name}\n\nEstimado/a ${payload.patient_name}:\nSe ha registrado como nuevo paciente y se agendó una cita el día ${payload.date} a las ${payload.time}\n\nClínica: ${payload.clinic_name} \nDirección: ${payload.clinic_address}\n`
    return WA
}

export { consultationPatientWA }